'use strict';

const provinceSelect = $('select[name="province_id"]');
const districtSelect = $('select[name="district_id"]');
const neighborhoodSelect = $('select[name="neighborhood_id"]');

const taxOfficeSelect = $('select[name="tax_office_id"]');
const bankSelect = $('select[name="bank_id"]');
const bankBranchSelect = $('select[name="bank_branch_id"]');

const vehicleBrandSelect = $('select[name="vehicle_brand_id"]');
const vehicleSeriesSelect = $('select[name="vehicle_series_id"]');
const vehicleModelSelect = $('select[name="vehicle_model_id"]');

$(document).ready(function () {
    provinceSelect.change(function (e) {
        if (districtSelect.length) {
            districtSelect.empty().trigger('change')
                .append('<option value="" disabled selected>Seçiniz</option>');

            if (e.target.value) {
                $.ajax({
                    url: '/api/common/provinces/' + e.target.value + '/districts',
                    localCache: true,
                    cacheKey: 'provinces/' + e.target.value,
                    success: function (data) {
                        districtSelect.empty().trigger('change')
                            .append('<option value="" disabled selected>Seçiniz</option>');
                        $.each(data, function (index, value) {
                            districtSelect.append('<option value="' + value.id + '">' + value.name + '</option>');
                        });

                        if (districtSelect.attr('data-old-id')) {
                            districtSelect.val(districtSelect.attr('data-old-id'))
                                .removeAttr('data-old-id').trigger('change');
                        } else if (data.length === 1) {
                            districtSelect.val(data[0].id).trigger('change');
                        }
                    }
                })
            }
        }

        if (taxOfficeSelect.length) {
            taxOfficeSelect.empty().trigger('change')
                .append('<option value="" disabled selected>Seçiniz</option>');

            if (e.target.value) {
                $.ajax({
                    url: '/api/common/provinces/' + e.target.value + '/taxOffices',
                    localCache: true,
                    cacheKey: 'provinces/' + e.target.value + '/taxOffices',
                    success: function (data) {
                        taxOfficeSelect.empty().trigger('change')
                            .append('<option value="" disabled selected>Seçiniz</option>');
                        $.each(data, function (index, value) {
                            taxOfficeSelect.append('<option value="' + value.id + '">' + value.name + '</option>');
                        });

                        if (taxOfficeSelect.attr('data-old-id')) {
                            taxOfficeSelect.val(taxOfficeSelect.attr('data-old-id'))
                                .removeAttr('data-old-id').trigger('change');
                        } else if (data.length === 1) {
                            taxOfficeSelect.val(data[0].id).trigger('change');
                        }
                    }
                })
            }
        }
    });

    districtSelect.change(function (e) {
        if (neighborhoodSelect.length) {
            neighborhoodSelect.empty().trigger('change')
                .append('<option value="" disabled selected>Seçiniz</option>');

            if (e.target.value) {
                $.ajax({
                    url: '/api/common/districts/' + e.target.value + '/neighborhoods',
                    localCache: true,
                    cacheKey: 'districts/' + e.target.value + '/neighborhoods',
                    success: function (data) {
                        neighborhoodSelect.empty().trigger('change')
                            .append('<option value="" disabled selected>Seçiniz</option>');
                        $.each(data, function (index, value) {
                            neighborhoodSelect.append('<option value="' + value.id + '">' + value.name + '</option>');
                        });

                        if (neighborhoodSelect.attr('data-old-id')) {
                            neighborhoodSelect.val(neighborhoodSelect.attr('data-old-id'))
                                .removeAttr('data-old-id').trigger('change');
                        } else if (data.length === 1) {
                            neighborhoodSelect.val(data[0].id).trigger('change');
                        }
                    }
                })
            }
        }

        if (bankSelect.length && bankSelect.val() && districtSelect.length && e.target.value) {
            bankBranchLoad(bankSelect.val(), e.target.value);
        }
    });


    vehicleBrandSelect.change(function (e) {
        if (vehicleSeriesSelect.length) {
            vehicleSeriesSelect.empty().trigger('change')
                .append('<option value="" disabled selected>Seçiniz</option>');

            if (e.target.value) {
                $.ajax({
                    url: '/api/common/vehicleBrands/' + e.target.value + '/vehicleSeries',
                    localCache: true,
                    cacheKey: 'vehicleBrands.' + e.target.value + '.vehicleSeries',
                    success: function (data) {
                        data.sort((a, b) => (a.name > b.name) ? 1 : -1);

                        vehicleSeriesSelect.empty().trigger('change')
                            .append('<option value="" disabled selected>Seçiniz</option>');
                        $.each(data, function (index, value) {
                            vehicleSeriesSelect.append('<option value="' + value.id + '">' + value.name + '</option>');
                        });

                        if (vehicleSeriesSelect.attr('data-old-id')) {
                            vehicleSeriesSelect.val(vehicleSeriesSelect.attr('data-old-id'))
                                .removeAttr('data-old-id').trigger('change');
                        } else if (data.length === 1) {
                            vehicleSeriesSelect.val(data[0].id).trigger('change');
                        }
                    }
                })
            }
        }
    });

    vehicleSeriesSelect.change(function (e) {
        if (vehicleModelSelect.length) {
            vehicleModelSelect.empty().trigger('change')
                .append('<option value="" disabled selected>Seçiniz</option>');

            if (e.target.value) {
                $.ajax({
                    url: '/api/common/vehicleSeries/' + e.target.value + '/vehicleModels',
                    localCache: true,
                    cacheKey: 'vehicleSeries.' + e.target.value + '.vehicleModels',
                    success: function (data) {
                        data.sort((a, b) => (a.name > b.name) ? 1 : -1);

                        vehicleModelSelect.empty();
                        vehicleModelSelect.append('<option value="" disabled selected>Seçiniz</option>');
                        $.each(data, function (index, value) {
                            vehicleModelSelect.append('<option value="' + value.id + '" data-json=\'' + JSON.stringify(value) + '\'>' + value.name + '</option>');
                        });

                        if (vehicleModelSelect.attr('data-old-id')) {
                            vehicleModelSelect.val(vehicleModelSelect.attr('data-old-id'))
                                .removeAttr('data-old-id').trigger('change');
                        } else if (data.length === 1) {
                            vehicleModelSelect.val(data[0].id).trigger('change');
                        }
                    }
                })
            }
        }
    });

    bankSelect.change(function (e) {
        if (bankBranchSelect.length && e.target.value && districtSelect.length && districtSelect.val()) {
            bankBranchLoad(e.target.value, districtSelect.val());
        }
    });


    if ($(':selected', provinceSelect).length) {
        provinceSelect.trigger('change');
    }

    if ($(':selected', vehicleModelSelect).length && vehicleModelSelect.val()) {
        vehicleModelSelect.trigger('change');
    }

    if ($(':selected', vehicleSeriesSelect).length && vehicleSeriesSelect.val()) {
        vehicleSeriesSelect.trigger('change');
    }

    if ($(':selected', vehicleBrandSelect).length && vehicleBrandSelect.val()) {
        vehicleBrandSelect.trigger('change');
    }

    if ($(':selected', bankSelect).length) {
        bankSelect.trigger('change');
    }


    function bankBranchLoad(bankId, districtId) {
        $.ajax({
            url: '/api/common/districts/' + districtId + '/bankBranches?bank_id=' + bankId,
            localCache: true,
            cacheKey: 'districts.' + districtId + '.bankBranches.' + bankId,
            success: function (data) {
                bankBranchSelect.empty()
                    .append('<option value="" disabled selected>Seçiniz</option>');

                $.each(data, function (index, value) {
                    bankBranchSelect.append('<option value="' + value.id + '">' + value.name + '</option>');
                });

                if (bankBranchSelect.attr('data-old-id')) {
                    bankBranchSelect.val(bankBranchSelect.attr('data-old-id'))
                        .removeAttr('data-old-id').trigger('change');
                } else if (data.length === 1) {
                    bankBranchSelect.val(data[0].id).trigger('change');
                }
            }
        })
    }
});
